import { keepPreviousData } from "@tanstack/react-query";
import { trpc } from "../trpc";

const SELECTED_APIS_CHUNK_SIZE = 30;

interface Input {
  selectedApis?: string[];
  includeMembers?: boolean;
}

interface Options {
  enabled?: boolean;
}

function chunkArray<T>(array: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let index = 0; index < array.length; index += size) {
    chunks.push(array.slice(index, index + size));
  }
  return chunks;
}

export function useQueryAppStats(
  { selectedApis, includeMembers }: Input,
  { enabled = true }: Options = {},
) {
  const chunks = chunkArray(selectedApis ?? [], SELECTED_APIS_CHUNK_SIZE);

  const queries = trpc.useQueries((t) =>
    chunks.map((chunk) =>
      t.app.appStats(
        { selectedApis: chunk, includeMembers },
        {
          enabled,
          placeholderData: keepPreviousData,
          staleTime: Infinity,
          trpc: {
            context: {
              skipBatching: true,
            },
          },
        },
      ),
    ),
  );

  const isLoading = queries.some((q) => q.isLoading);
  const isFetching = queries.some((q) => q.isFetching);

  const appStats = queries.every((q) => q.data)
    ? queries.flatMap((q) => q.data ?? [])
    : undefined;

  return {
    appStats,
    isLoading,
    isFetching,
  };
}
